export const LabelHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <div className="font-header uppercase font-bold text-hoveredSecondary mb-2">
      {children}
    </div>
  )
}
